import { IManagerDashboardState } from "../../types";
import { ManagerDashboardActions } from "../actions";
import {
  MANAGER_DASHBOARD_FULFILLED,
  MANAGER_DASHBOARD_PENDING,
  MANAGER_DASHBOARD_REJECTED,
  TEAM_OVERVIEW_FULFILLED,
  TEAM_OVERVIEW_PENDING,
  TEAM_OVERVIEW_REJECTED
} from "../constants";

const initialState: IManagerDashboardState = {
  items: { reports: [], teamDetails: [], pending: true, completed: false, rejected: false },
  overView: {
    pending: true,
    completed: false,
    rejected: false,
    data: {
      proposedFinalRating: [],
      selfAssessment: [],
      signedFinalRating: [],
      supervisorFeedback: [],
      talks: []
    }
  }
};

export default (state = initialState, action: ManagerDashboardActions) => {
  switch (action.type) {
    case TEAM_OVERVIEW_PENDING:
      return {
        ...state,
        overView: {
          completed: false,
          pending: true,
          rejected: false,
          data: initialState.overView.data
        }
      };
    case TEAM_OVERVIEW_FULFILLED:
      return {
        ...state,
        overView: {
          completed: true,
          pending: false,
          rejected: false,
          data: action.payload
        }
      };
    case TEAM_OVERVIEW_REJECTED:
      return {
        ...state,
        overView: {
          completed: false,
          data: initialState.overView.data,
          pending: false,
          rejected: true
        }
      };
    case MANAGER_DASHBOARD_PENDING:
      return {
        ...state,
        items: {
          completed: false,
          reports: initialState.items.reports,
          teamDetails: initialState.items.teamDetails,
          pending: true,
          rejected: false
        }
      };
    case MANAGER_DASHBOARD_FULFILLED:
      return {
        ...state,
        items: {
          completed: true,
          reports: action.payload.reports,
          teamDetails: action.payload.teamDetails,
          pending: false,
          rejected: false
        }
      };
    case MANAGER_DASHBOARD_REJECTED:
      return {
        ...state,
        items: {
          completed: false,
          reports: initialState.items.reports,
          teamDetails: initialState.items.teamDetails,
          pending: false,
          rejected: true
        }
      };
    default:
      return state;
  }
};
